import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';
import { vibrate } from '../utils/haptics';
import './DailyStreakAnimation.css';

import { Picto, EmojiText } from './common/Picto';
interface DailyStreakAnimationProps {
  show: boolean;
  streakCount: number;
  onClose: () => void;
}

const getMessageKey = (count: number): string => {
  if (count >= 100) return 'dailyStreak.message100';
  if (count >= 60)  return 'dailyStreak.message60';
  if (count >= 30)  return 'dailyStreak.message30';
  if (count >= 14)  return 'dailyStreak.message14';
  if (count >= 7)   return 'dailyStreak.message7';
  if (count >= 3)   return 'dailyStreak.message3';
  if (count >= 2)   return 'dailyStreak.message2';
  return 'dailyStreak.message1';
};

const DailyStreakAnimation: React.FC<DailyStreakAnimationProps> = ({ show, streakCount, onClose }) => {
  const { t } = useTranslation();
  useEffect(() => {
    if (show) vibrate('dailyStreak');
  }, [show]);

  useEffect(() => {
    if (show) {
      const timer = setTimeout(onClose, 4500);
      return () => clearTimeout(timer);
    }
  }, [show, onClose]);

  if (!show) return null;

  return ReactDOM.createPortal(
    <div className="ds-backdrop" onClick={onClose}>
      <div className="ds-modal" onClick={e => e.stopPropagation()}>
        <div className="ds-flame"><Picto name="feu" /></div>
        <div className="ds-count">{streakCount}</div>
        <div className="ds-label">
          {streakCount === 1 ? t('dailyStreak.dayLabel') : t('dailyStreak.daysLabel')}
        </div>
        <div className="ds-message"><EmojiText text={t(getMessageKey(streakCount)) as string} /></div>
        <button className="ds-button" onClick={onClose}>{t('dailyStreak.button')}</button>
      </div>
    </div>,
    document.body
  );
};

export default DailyStreakAnimation;
